import { render, staticRenderFns } from "./Update-Profile.vue?vue&type=template&id=5ec89df2&scoped=true&"
import script from "./Update-Profile.vue?vue&type=script&lang=js&"
export * from "./Update-Profile.vue?vue&type=script&lang=js&"
import style0 from "./Update-Profile.vue?vue&type=style&index=0&id=5ec89df2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec89df2",
  null
  
)

export default component.exports